export const applyDrag = (arr: any[], dragResult: any) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

export const generateItems = (arr: any[]) => {
  const result = [];
  for (let i = 0; i < arr.length; i++) {
    const obj = { id: i, data: arr[i] };
    result.push(obj);
  }
  return result;
};

export const degenerateItems = (arr: any[]) => {
  const result = [];
  for (let i = 0; i < arr.length; i++) {
    const obj = arr[i].data;
    result.push(obj);
  }
  return result;
};
